module.exports = {
  body: {
    textColor:'text-black',
    backgroundColor:'bg-white',
    backgroundColorPrimary:'bg-primary',

    selectedBackgroundColor:'bg-primary',
    selectedTextColor:'text-white',

    defaultBackgroundImage: false,
    defaultBackgroundImageColor: '2d2d2d',

    backgroundColorDEFAULT: '#fff',
    primaryLoaderColor: 'black',
    primaryColor: 'primary',
    selectedItem: 'primary',
    TypeDisplayColor: 'primary',
    deleteButtonTextColor: 'text-red-600',
    startButtonTextColor:'text-white',
    startButtonBackgroundColor:'bg-primary',
    defaultTextColorButton:'text-white'
  },
  card: {
    backgroundColorHavingSubItem: 'bg-gray-100',
    backgroundColor: 'bg-gray-200',
    title: 'text-gray-1000',
    iconWrapper: 'bg-gray-300'
  },
  addToCart: {
    textColorPlus:'text-white',
    backgroundColor: 'bg-white',
    backgroundColorPlus:'bg-primary',
    backgroundColorMinus:'bg-primary',
    textColor:'bg-white',
    border: '',
    title: 'text-primary',
    notSelectedBackgroundColor: 'bg-gray-300',
    selectedBackgroundColor:'bg-primary',
    addToCartButtonBackgroundColor:'bg-primary',
    addToCartButtonTextColor:'text-white',
    deleteButtonTextColor: 'text-red-600'
  },
  footer: {
    button: 'outline-none w-half hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center bg-gray-600'
  },
  header: {
    backgroundColor:'bg-gray-200',
    selectedItemColor:'primary'
  },
  middleScreen: {
    backgroundColor:''
  },
  processBar: {
    itemDoneTextColor: 'text-primary',
    itemDoneBackgroundColor: 'bg-primary',
    currentItemTextColor:'text-gray-600',
    currentItemBackgroundColor:'bg-gray-600',
    futureItemBackgroundColor: 'bg-gray-300',
    futureItemTextColor: 'text-black',
    futureItemBottomTextColor:'text-gray-300'
  },
  floatingCartInfoButton: {
    unabledButtonBrackgroundColor:'bg-gray-500'
  },
  paymentMethod:
  {
    textColor:'text-black',
    arrowTextolor:'text-white'
  },
  AdditionsPopUp:
  {
    HeadertextColor:'text-black',
    HeaderTextBackgroundColor:'bg-green-200'
  },
  Cart:
  {
    backgroundColor: 'bg-gray-200'
  }
}